import PropTypes from "prop-types";
import MDInput from "components/MDInput";

/**
 * Ô chọn: chỉ là `<MDInput select>` với tên gọi rõ nghĩa hơn ở nơi dùng.
 *
 * Chiều cao và mũi tên xổ xuống được sửa ở theme (`assets/theme/components/form/select.js`),
 * không sửa ở đây: bản gốc Material Dashboard đặt `padding: 0 12px !important` cho `.MuiSelect-select`
 * nên không `sx` nào ở phía component đè lại được.
 */
function SelectField({ children, ...rest }) {
  return (
    <MDInput select {...rest}>
      {children}
    </MDInput>
  );
}

SelectField.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SelectField;
